<template>
  <div class="awdoc-image pb-5 pt-5">
    <b-container class="h-100">
      <b-row align-h="center" align-v="center" class="h-75">
        <b-col cols="12" sm="12" md="6" >
          <b-card class="mt-4 form-image">
            <b-form id="login-form" @keyup.enter="doLogin" class="pt-5">
              <b-row align-h="center">
                <h5 class="label">Inserisci le tue credenziali AWDoc</h5>
                <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                  <!-- User -->
                  <b-form-group>
                    <b-form-input v-model="input.username"
                                  autocomplete="current-username"
                                  id="input-username"
                                  class="mt-3"
                                  :placeholder="$tc('message.user', 1)">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                  <!-- Password -->
                  <b-form-group>
                    <b-form-input v-model="input.password"
                                  autocomplete="current-password"
                                  id="input-password"
                                  type="password"
                                  :placeholder="$t('message.pin')">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row align-h="center" align-v="center">
                <b-col>
                  <b-button  v-on:click="doLogin" class="b-c-blue" :disabled="!input.username || !input.password">
                    {{$tc('message.ok', 1)}}
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'
export default {
  name: 'AWDocAuthentication',
  data () {
    const BASE_URL_AWDOC = Vue.getBaseUrlAWDoc()
    const ORGANIZATION = Vue.getOrganization()
    return {
      input: {},
      BASE_URL_AWDOC,
      ORGANIZATION
    }
  },
  methods: {
    async doLogin () {
      const config = {
        method: 'get',
        url: this.BASE_URL_AWDOC + '/login',
        headers:
            {
              Authorization: 'Basic ' + btoa(this.ORGANIZATION + ':' + this.input.username + ':' + this.input.password)
            },
        data: ''
      }

      axios(config)
        .then(() => {
          Vue.success(this, `${this.$tc('message.login')} ${this.$tc('message.done', 1).toLowerCase()}`)
          this.input = {}
        })
        .catch((error) => {
          console.log(error)
          Vue.error(this, this.$t('errors.generic'))
        })
    }
  }
}
</script>

<style scoped>
.awdoc-image {
  height: 100%;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  padding: 0;
  margin: 0;
  background: url('../../static/MainBackground.png') no-repeat center;
  background-size: cover;
}

.form-image {
  width: 450px;
  height: 440px;
  max-width: 100%;
  max-height: 100%;
  padding: 0;
  margin: 0;
  background: url('../../static/FinestraLogin.png') no-repeat center;
  background-size: cover;
  border-radius: 10px;
  border: 1px solid rgb(117, 157, 192);
  font-family: sans-serif;
}

input[type=text], [type=password] {
  width: 97.7%;
  height: 34px;
  padding: 5px;
  margin: 10px;
  color: #4f4f4f;
}

.label {
  text-align: center;
  color: rgb(0, 103, 177);
  font-weight: bold;
}

.b-c-blue{
  font-size: 20px;
  margin: 15px auto;
  display: block;
  background: rgb(0, 104, 179);
  padding: 7px 35px;
  color: white;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
  border: none;
}

</style>
